module.exports = __webpack_public_path__ + "media/Conf_Clock_Hours.17a7898b.mp4";